var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom",attrs:{"id":"mobileBottom"}},[_c('div',{staticClass:"text-center mb-2 font_14"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" 上海帆扬宇亿科技有限公司 AII rights reserved")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center font_14"},[_c('div',{staticClass:"mb-2"},[_vm._v("沪ICP备2024062463号-2")])])
}]

export { render, staticRenderFns }